module.exports = __webpack_public_path__ + "img/banner_4.3b6517b7.jpg";